export default "__VITE_ASSET__DSkuJjoT__"